module.exports = __webpack_public_path__ + "img/linkedin.af993e8e.svg";